import { Link, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Lottie from 'react-lottie-player';

import * as animationData from 'assets/Signin_Erply.json';

import packageJson from '../../../package.json';

const IllustrationLayout = styled.div`
  background-color: ${({ theme: { shade } }) => shade['25']};

  display: flex;
  flex-flow: column;
  .animation {
    margin: auto 0;
  }
  > :last-child {
    margin-top: auto;
  }

  padding: 2.5rem 2rem 1rem 2rem;

  min-width: 23rem;
  height: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

interface Props {
  children?: never;
}

const Illustration: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <IllustrationLayout>
      <Typography align="center">
        {t('illustration.subText1')}
        <Link href="/registration">{t('illustration.subText2')}</Link>
      </Typography>
      <Lottie
        className="animation"
        loop
        play
        animationData={animationData}
        style={{ height: 380, width: 318 }}
      />
      <Typography align="center">
        {t('illustration.version', { version: packageJson.version })}
      </Typography>
    </IllustrationLayout>
  );
};

export default Illustration;
